export default {
    // state 屬於模組區域變數
    // actions, mutations, getters 是屬於全域變數
  namespaced: true,     // actions, mutations, getters 是屬於區域變數
  state: {
    requestSearchObj: {rows: [] , filter: {pageSize: 10 , pageIndex: 1} ,totalCount: 0 }, //招標及報價查詢結果+查詢條件
  },
  actions: {
    searchRequest(context, parameter) {         
        parameter.func =null;        

        const filter = context.getters.requestSearchObj.filter;
        let params = {...filter}
        Object.assign(params, parameter);
        //--修正查詢參數中 StartDateBegin StartDateEnd  DeadlineBegin DeadlineEnd 若為空字串轉為 null
        const fixQry = ['CreateTimeStart','CreateTimeEnd'];
        fixQry.forEach(it=>{
          if(params[it] === ''){
            params[it] = null;
          }
        });    
        
        let obj = {};
        obj.filter = params;
        context.commit('ChangeRequestSearchResult', obj);
    },

  },
  mutations: {
    ChangeRequestSearchResult(state, payload) {//存入 招標及報價查詢結果
        let obj = state.requestSearchObj;
        obj.rows = payload.rows;
        obj.filter = payload.filter;
        obj.totalCount = payload.totalCount;
    },
  },
  getters: {
    requestSearchObj: state => state.requestSearchObj,
  },
  
}